const trimTrailingSlashes = (url) =>
  typeof url === "string" ? url.replace(/\/+$/, "") : "";

/** OAuth redirect target — always the public Node/ngrok URL */
export const NODE_API_URL =
  trimTrailingSlashes(
    process.env.REACT_APP_OAUTH_API_URL || process.env.REACT_APP_API_URL,
  ) || "http://localhost:8001";
/** API routes (session JWT auth) live under /api — including POST install/status */
export const NODE_API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || "/api";

/** XHR base URL — ngrok backend + /api */
export const API_BASE_URL = process.env.REACT_APP_API_URL
  ? `${trimTrailingSlashes(process.env.REACT_APP_API_URL)}${NODE_API_BASE_PATH}`
  : `${NODE_API_URL}${NODE_API_BASE_PATH}`;

export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN || "http://localhost:3000";
export const REACT_APP_BASE_PATH = process.env.REACT_APP_BASE_PATH || "";

export const SHOPIFY_API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY || "";

export const THEME_APP_EMBED_HANDLE = (
  process.env.REACT_APP_THEME_APP_EMBED_HANDLE || "free-shipping-bar"
).trim();

export const THEME_EDITOR_LINK_MODE = (
  process.env.REACT_APP_THEME_EDITOR_LINK_MODE || "activate_embed"
).trim();

export const SHOPIFY_APP_HANDLE = (process.env.REACT_APP_SHOPIFY_APP_HANDLE || "").trim();
export const ROUTER_BASENAME = SHOPIFY_APP_HANDLE ? `/${SHOPIFY_APP_HANDLE}` : "";

export const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";

export const buildNodeApiEntryUrl = (shop, host = null) => {
  if (!shop) return `${NODE_API_URL}/`;
  return host
    ? `${NODE_API_URL}/?shop=${encodeURIComponent(shop)}&host=${encodeURIComponent(host)}`
    : `${NODE_API_URL}/?shop=${encodeURIComponent(shop)}`;
};

export const APP_BASE_URL = `${REACT_APP_DOMAIN}${REACT_APP_BASE_PATH}`;

const config = {
  nodeApi: {
    url: NODE_API_URL,
    basePath: NODE_API_BASE_PATH,
    fullUrl: API_BASE_URL,
  },
  reactApp: {
    domain: REACT_APP_DOMAIN,
    basePath: REACT_APP_BASE_PATH,
    fullUrl: APP_BASE_URL,
  },
  shopify: {
    apiKey: SHOPIFY_API_KEY,
  },
  env: {
    isProduction: IS_PRODUCTION,
    isDevelopment: IS_DEVELOPMENT,
    nodeEnv: process.env.NODE_ENV,
  },
};

export default config;
